import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const OverdueStatisticCards = ({ cards, formatCurrency }) => (
	<div className='row dashboard-overdue-stat-cards'>
		{cards.map((card, index) => (
			<div key={index} className='col-6 col-md-3'>
				<div
					className='card border-0 statistic-card'
					style={{
						background: card.bgGradient,
						cursor: 'pointer',
						display: 'flex',
						flexDirection: 'column',
					}}
					onMouseEnter={(e) => {
						e.currentTarget.style.boxShadow = card.hoverShadow;
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.boxShadow = '';
					}}
				>
					<FontAwesomeIcon icon={card.icon} className={`text-${card.color} statistic-card-icon-bg`} style={{ fontSize: '4rem' }} />
					<div className='card-body'>
						<div className='flex-grow-1' style={{ paddingRight: '1.5rem', minHeight: 0 }}>
							<div className='d-flex align-items-center gap-2 mb-1' style={{ gap: '0.5rem' }}>
								<div
									className={`bg-${card.color} bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center`}
									style={{ width: '28px', height: '28px', minWidth: '28px', flexShrink: 0 }}
								>
									<FontAwesomeIcon icon={card.icon} className={`text-${card.color}`} style={{ fontSize: '0.75rem' }} />
								</div>
								<span className='text-muted small fw-semibold text-uppercase' style={{ fontSize: '0.65rem', letterSpacing: '0.5px', lineHeight: '1.2' }}>
									{card.title}
								</span>
							</div>
							<div
								className={`fw-bold statistic-card-value text-${card.color}`}
								style={{ fontSize: '1.1rem', lineHeight: '1.3', wordBreak: 'break-word', marginBottom: '0.25rem' }}
							>
								{formatCurrency(card.value)}
							</div>
						</div>
						<div className='d-flex align-items-center justify-content-between' style={{ paddingRight: '1.5rem', marginTop: 'auto' }}>
							<div className='d-flex align-items-center gap-1'>
								<FontAwesomeIcon icon='file-invoice' className='text-muted' style={{ fontSize: '0.7rem' }} />
								<span className='text-muted small fw-medium' style={{ fontSize: '0.7rem', lineHeight: '1.2' }}>
									{card.count} 个订单
								</span>
							</div>
							<div className={`badge bg-${card.color} bg-opacity-10 text-${card.color} border-0`} style={{ fontSize: '0.6rem', flexShrink: 0, padding: '0.2rem 0.4rem' }}>
								{card.value > 0 ? '有数据' : '无数据'}
							</div>
						</div>
					</div>
				</div>
			</div>
		))}
	</div>
);

export default OverdueStatisticCards;
